import { useEffect, useState } from 'react'
import { Button, CircularProgress, Dialog, DialogTitle } from '@mui/material'
import axios from 'axios'
import ReactGA from 'react-ga4'
import { useNavigate } from 'react-router-dom'
import { AppConstants, LeadStage } from 'AppConstants/AppConstants'
import Footer from 'components/Footer'
import Header from 'components/Header'
import useQueryParams from 'hooks/useQueryParams'
import { studio } from 'redux/persist'
import { SetSelectedStudioSignUp, SetStudiosSignUp } from 'redux/SignUp/persist'
import { useAppDispatch, useAppSelector } from 'redux/store'
import { createNavigateWithQueryParams } from 'utils/navigateWithQueryParams'
import styles from './Location.module.scss'

const LocationSignUp = () => {
  const { getAllParams, getParams } = useQueryParams()
  const utm_source = getParams('utm_source')
  const loc = getParams('loc')
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  // Signup flow state management
  const studios = useAppSelector((state) => state.signUpPersist.studiosSignUp)
  const selectedStudio = useAppSelector((state) => state.signUpPersist.selectedStudioSignUp)
  const isMoreThanOneStudio = useAppSelector((state) => state.signUpPersist.isMoreThanOneStudioSignUp)
  const trackerCount = useAppSelector((state) => state.signUpPersist.trackerCountSignUp)

  // Create reusable navigation function
  const navigateWithQueryParams = createNavigateWithQueryParams(navigate, getAllParams)

  console.log(studios, 'this is the list of studios')

  const getAllStudios = async () => {
    const response: any = await axios
      .get(AppConstants.API_URL + '/clinic', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
        },
      })
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err.response
      })

    if (response?.data?.code === 'success') {
      dispatch(SetStudiosSignUp(response?.data?.data))
    }
  }
  const postLeadStage = async () => {
    await axios
      .post(
        AppConstants.API_URL + '/lead/stage/update',
        { stage: LeadStage.location },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
          },
        },
      )
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err?.response
      })
  }

  useEffect(() => {
    postLeadStage()
  }, [])

  useEffect(() => {
    ReactGA.event('page_view', {
      page_title: 'SignUp|Location',
      page_location: `/signup/location`,
    })

    if (utm_source === 'facebook' || utm_source === 'meta') {
      //@ts-ignore
      fbq('track', 'ViewContent')
    }
    if (utm_source === 'tiktok') {
      //@ts-ignore
      ttq.track('SubmitForm')
      //@ts-ignore
      ttq.track('SubmitApplication')
    }
  }, [utm_source])

  useEffect(() => {
    getAllStudios()
  }, [])

  const filteredStudios = [...(studios ?? [])].sort((a: studio, b: studio) => {
    if (!loc) return 0
    const aMatch = a.slug?.toLowerCase() === loc.toLowerCase()
    const bMatch = b.slug?.toLowerCase() === loc.toLowerCase()
    if (aMatch && !bMatch) return -1
    if (!aMatch && bMatch) return 1
    return 0
  })
  const hasMoreLocations = filteredStudios.length >= 6

  return (
    <>
      <div className={styles.container}>
        {/* <Header
          headerText="Select the location that works best for you."
          showBackButton={false}
          // onBack={() => {
          //   navigate('/choose-plan')
          // }}
        ></Header> */}
        <div className={styles.header}>
          <div className={styles.headerText}>
            <span>{'Select the location that'}</span>
            <span>{`works best for you.`}</span>
          </div>
          <img src={'/logo2.png'} alt="logo" className={styles.logo} />
        </div>
        <div
          className={`${styles.locationWrapper} ${hasMoreLocations ? styles.locationWrapperWithPeek : ''}`}
          style={{ cursor: 'pointer' }}
        >
          {filteredStudios.map((s: studio) => {
            return (
              <div
                className={styles.locationContainer}
                style={{
                  background: selectedStudio && selectedStudio.id === s.id ? '#007F7C' : 'transparent',
                  border:
                    selectedStudio && selectedStudio.id === s.id
                      ? '1px solid #007F7C'
                      : '1px solid var(--color-border-primary)',
                  color:
                    selectedStudio && selectedStudio.id === s.id
                      ? 'var(--color-text-secondary)'
                      : 'var(--color-text-primary)',
                }}
                key={s.id}
                onClick={() => {
                  dispatch(SetSelectedStudioSignUp(s))
                }}
              >
                <div className={styles.locationDetails}>
                  <div className={styles.locationTextContainer}>
                    <div className={styles.locationTextWrapper}>
                      <div className={styles.locationName}>{s.name}</div>
                      <div>
                        <div className={styles.locationText}>{s.address}</div>
                        <div className={styles.cityAndState}>
                          <div style={{ marginRight: '4px' }}>{s.city.name + ','}</div>
                          <div style={{ marginRight: '4px', textTransform: 'uppercase' }}>{s.state}</div>
                          <div>{s.zipCode}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <img
                    style={{
                      // width: '126px',
                      // height: '95.9px',
                      cursor: 'pointer',
                      objectFit: 'cover',
                    }}
                    className={styles.mapImageItem}
                    src={s?.mapImage ? s.mapImage : ''}
                    alt="map"
                    onClick={() => {
                      if (s?.mapLocation) {
                        window.open(s?.mapLocation, '_blank')
                      }
                    }}
                  />
                </div>
              </div>
            )
          })}
        </div>

        <Footer
          buttonText={'Continue'}
          isLoading={false}
          trackerIndex={4}
          shouldShowFour={true}
          shouldShowFive={true}
          shouldShowSix={true}
          shouldShowSeven={trackerCount >= 7}
          shouldShowEight={trackerCount >= 8}
          isDisabled={!selectedStudio}
          buttonType={'button'}
          onButtonClick={() => {
            if (selectedStudio) {
              navigateWithQueryParams('/signup/slot')
            }
          }}
        />
      </div>
    </>
  )
}

export default LocationSignUp
